import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import conciergeApiClient from 'Services/Apis/Concierge/conciergeApiClient';

export const getRequestPaginationSolicitationThunk = createAsyncThunk(
    `RequestPaginationSolicitationSlicer/getRequestPaginationSolicitationThunk`,
    async ({ current, pageSize, term, statusId }, { getState }) => {
        const { user } = getState().oidc;

        const headers = {
            Authorization: `Bearer ${user.access_token}`,
            campaignId: user.profile['custom:campaign_id'],
            catalogId: user.profile['custom:catalog_id'],
            participantId: user.profile['custom:participant_id'],
            username: user.profile.username || user.profile['custom:login'],
            'Content-Type': 'application/json'
        };

        const params = {
            current,
            pageSize,
            term,
            statusId,
        };

        const config = {
            headers,
            params
        }

        const { data } = await conciergeApiClient.get(`Redemption`, config);

        return data;
    }
);

const initialState = {
    dataRequestPaginationSolicitation: {},
    loadingRequestPaginationSolicitation: false,
    errorRequestPaginationSolicitation: false,
};

const RequestPaginationSolicitationSlicer = createSlice({
    name: 'requestPaginationSolicitation',
    initialState,
    reducers: {
        resetDataRequestPaginationSolicitation: (state) => {
            state.dataRequestPaginationSolicitation = {};
            state.loadingRequestPaginationSolicitation = false;
            state.errorRequestPaginationSolicitation = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getRequestPaginationSolicitationThunk.pending, (state) => {
            state.dataRequestPaginationSolicitation = {};
            state.loadingRequestPaginationSolicitation = true;
            state.errorRequestPaginationSolicitation = false;
        });
        builder.addCase(getRequestPaginationSolicitationThunk.fulfilled, (state, action) => {
            state.dataRequestPaginationSolicitation = action.payload;
            state.loadingRequestPaginationSolicitation = false;
            state.errorRequestPaginationSolicitation = false;
        });
        builder.addCase(getRequestPaginationSolicitationThunk.rejected, (state) => {
            state.dataRequestPaginationSolicitation = {};
            state.loadingRequestPaginationSolicitation = false;
            state.errorRequestPaginationSolicitation = true;
        });
    },
});

export const { resetDataRequestPaginationSolicitation } = RequestPaginationSolicitationSlicer.actions;
export default RequestPaginationSolicitationSlicer.reducer;